"use client";

import { AnimateOnScroll } from "./animate-on-scroll";

const PHOTOS = [
  { src: "/images/arizona-landmarks/saguaro-cactus-arizona.jpg", pos: "center 40%" },
  { src: "/images/arizona-landmarks/antelope-canyon-arizona.jpg", pos: "center 50%" },
  { src: "/images/tempe-town-lake-bridge.jpg", pos: "center 50%" },
  { src: "/images/arizona-landmarks/monument-valley-arizona.jpg", pos: "center 40%" },
  { src: "/images/arizona-landmarks/horseshoe-bend-arizona.jpg", pos: "center 30%" },
];

export function PhotoDivider({
  index = 0,
  height = "50vh",
  overlay = "rgba(0,0,0,0.45)",
  children,
}: {
  index?: number;
  height?: string;
  overlay?: string;
  children?: React.ReactNode;
}) {
  const photo = PHOTOS[index % PHOTOS.length];

  return (
    <section
      style={{
        position: "relative",
        height,
        minHeight: "360px",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage: `url('${photo.src}')`,
          backgroundSize: "cover",
          backgroundPosition: photo.pos,
          backgroundAttachment: "fixed",
          backgroundRepeat: "no-repeat",
        }}
      />
      <div style={{ position: "absolute", inset: 0, background: overlay }} />
      {children && (
        <AnimateOnScroll>
          <div
            style={{
              position: "relative",
              zIndex: 1,
              textAlign: "center",
              padding: "40px 24px",
              maxWidth: "700px",
            }}
          >
            {children}
          </div>
        </AnimateOnScroll>
      )}
    </section>
  );
}
